<!--

AlertHandler
------------

-->

<template>
    <div>
        <b-modal ref="alert-modal"
            title="A Roads!"
            :ok-only="true">
            <h3 class="my-4" v-if="title.length > 0">
                {{title}}
            </h3>
            <p>
                {{message}}
            </p>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import {BModal} from 'bootstrap-vue'
    import {EventBus} from '../../modules/eventbus.js'

    // Export the component.
    export default {
        components: {
            'b-modal': BModal
        },
        data: function() {
            return {
                message: '',
                title: ''
            }
        },
        methods: {
            handleAlert: function(args) {
                if (args.message) this.message = args.message
                if (args.title) this.title = args.title
                this.showModal()
            },
            showModal: function() {
                this.$refs['alert-modal'].show()
            },
            hideModal: function() {
                this.message = ""
                this.$refs['alert-modal'].hide()
            }
        },
        created: function() {
            EventBus.$on("alert", function(args) {
                this.handleAlert(args)
            }.bind(this))
       }
    }
</script>